import errorIcon from '@/assets/login_page/error_icon.svg';
import warnIcon from '@/assets/login_page/yellow_info_icon.svg';
import styles from './ErrorTips.module.css';

export default function ErrorTips({
  errorText, showSorry = true, type = 'error', className,
}) {
  const icon = type === 'error' ? errorIcon : warnIcon;
  return (
    <div
      className={`
        ${styles.container} 
        ${className} 
        ${type === 'error' ? styles.error : styles.warn} 
        `}
    >
      <img alt="icon" src={icon} />

      <div className="error_tips">
        {showSorry && <div className={styles.sorryText}>Sorry</div>}
        <div className={styles.text}>{errorText}</div>
      </div>
    </div>
  );
}
